import { selectDeclType,selectTransmissionTypeList,selectCircuit } from "@EUForms/selectors";
import { createSelector } from "reselect";
import { transmisisonMapping } from "./util";

  const createParameterSelector=(selector)=> (_, params) => selector(params)
  
  const getisEntryStateParam = createParameterSelector(params => params.entryState);
  const getisCustomStateParam = createParameterSelector((params) => params.customState)

  export const selectFilterTransmisisonTypeList = createSelector(
    [
      selectTransmissionTypeList,
      getisEntryStateParam,
      selectDeclType,
      selectCircuit,
      getisCustomStateParam,
    ],
    (transmissionList, entryState, declType, circuit, customState) => {
      if (!declType || !entryState || transmissionList?.length == 0) return []

      return transmissionList.filter((item) => {
        const mapping = transmisisonMapping()
        const {
          decTypes = [],
          entryStates = [],
          circuits = [],
          NotCustomStates = [],
        } = mapping[item.value] || {}
        return (
          entryStates.includes(entryState) &&
          !NotCustomStates.includes(customState) &&
          (decTypes ? decTypes.includes(declType) : true) &&
          (circuits ? circuits.includes(circuit) : true)
        )
      })
    }
  )